export function stripHtmlSpaces(str = "") {
  return (
    str ? decodeURI(encodeURI(str).replace(/\%C2\%A0/g," ")) : str
  )
}
